var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.threadState != "closed"
    ? _c(
        "div",
        {
          ref: "footer",
          staticClass: "footer",
          class: { has_cart_share: _vm.shareCartAvailable },
        },
        [
          this.moreActive
            ? _c(
                "div",
                { staticClass: "more-container", attrs: { tabindex: "0" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "option-footer",
                      on: { click: _vm.filesActive },
                    },
                    [
                      _c("button", {
                        staticClass: "action-icon paperclip",
                        attrs: {
                          tabindex: "0",
                          title: _vm.$gettext("Adjuntar archivo"),
                        },
                      }),
                      _c("p", [
                        _vm._v(_vm._s(_vm.$gettext("Adjuntar archivo"))),
                      ]),
                    ]
                  ),
                  _vm.shareCartAvailable
                    ? _c(
                        "div",
                        {
                          staticClass: "option-footer",
                          on: { click: _vm.shareCart },
                        },
                        [
                          _c("button", {
                            staticClass: "action-icon cart",
                            attrs: {
                              tabindex: "0",
                              title: _vm.$gettext("Compartir carrito"),
                            },
                          }),
                          _c("p", [
                            _vm._v(
                              _vm._s(_vm.$gettext("Compartir carrito")) + " "
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _c("div", { staticClass: "inputs" }, [
            _c(
              "div",
              {
                staticClass: "inputs__text",
                class: { borderMaxCharacters: _vm.maxCharacters === 200 },
              },
              [
                _vm.shareCartAvailable
                  ? _c("button", {
                      staticClass: "action-icon more",
                      attrs: {
                        tabindex: "0",
                        title: _vm.$gettext("Más opciones"),
                      },
                      on: { click: _vm.handleMore },
                    })
                  : _c("button", {
                      staticClass: "action-icon only-paperclip",
                      attrs: {
                        tabindex: "0",
                        title: _vm.$gettext("Adjuntar archivo"),
                      },
                      on: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.toggleFiles.apply(null, arguments)
                        },
                        click: _vm.toggleFiles,
                      },
                    }),
                !_vm.isMobile()
                  ? _c("emoji-picker", {
                      staticClass: "emoji__container",
                      attrs: { search: _vm.search },
                      on: { emoji: _vm.insert },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "emoji-invoker",
                            fn: function ({ events: { click: clickEvent } }) {
                              return _c(
                                "button",
                                {
                                  staticClass: "emoji-invoker",
                                  attrs: {
                                    title: _vm.$gettext(
                                      "Abrir selector de emojis"
                                    ),
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return clickEvent.apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "h-6 w-6 fill-current text-grey",
                                      attrs: {
                                        viewBox: "0 0 24 24",
                                        xmlns: "http://www.w3.org/2000/svg",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M0 0h24v24H0z",
                                          fill: "none",
                                        },
                                      }),
                                      _c("path", {
                                        attrs: {
                                          d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            },
                          },
                          {
                            key: "emoji-picker",
                            fn: function ({ emojis, insert, display }) {
                              return _c(
                                "div",
                                { staticClass: "emojis__pckt" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "emoji-picker",
                                      style: {
                                        top: "auto",
                                        bottom: "3rem",
                                        left: "3rem",
                                        right: "0",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "emoji-picker__search" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.search,
                                                expression: "search",
                                              },
                                              {
                                                name: "focus",
                                                rawName: "v-focus",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              title:
                                                _vm.$gettext("Buscar emoji"),
                                              placeholder:
                                                _vm.$gettext("Buscar emoji"),
                                            },
                                            domProps: { value: _vm.search },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.search = $event.target.value
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        _vm._l(
                                          emojis,
                                          function (emojiGroup, category) {
                                            return _c(
                                              "div",
                                              {
                                                key: category,
                                                staticClass: "emojisGroup",
                                              },
                                              [
                                                _c("h5", [
                                                  _vm._v(_vm._s(category)),
                                                ]),
                                                _c(
                                                  "div",
                                                  { staticClass: "emojis" },
                                                  _vm._l(
                                                    emojiGroup,
                                                    function (
                                                      emoji,
                                                      emojiName
                                                    ) {
                                                      return _c(
                                                        "span",
                                                        {
                                                          key: emojiName,
                                                          attrs: {
                                                            tabindex: "0",
                                                            title: emojiName,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return insert(
                                                                emoji
                                                              )
                                                            },
                                                            keyup: function (
                                                              $event
                                                            ) {
                                                              if (
                                                                !$event.type.indexOf(
                                                                  "key"
                                                                ) &&
                                                                _vm._k(
                                                                  $event.keyCode,
                                                                  "enter",
                                                                  13,
                                                                  $event.key,
                                                                  "Enter"
                                                                )
                                                              )
                                                                return null
                                                              return insert(
                                                                emoji
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(emoji))]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            },
                          },
                        ],
                        null,
                        false,
                        2505850892
                      ),
                    })
                  : _vm._e(),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.message,
                      expression: "message",
                    },
                  ],
                  attrs: {
                    maxlength: "200",
                    placeholder: _vm.$gettext("Escribe aquí"),
                    title: _vm.$gettext("Campo de texto para escribir mensaje"),
                  },
                  domProps: { value: _vm.message },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) return
                        _vm.message = $event.target.value
                      },
                      _vm.handleInput,
                    ],
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.getMessage.apply(null, arguments)
                    },
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      $event.preventDefault()
                      return _vm.enterKeyDown.apply(null, arguments)
                    },
                  },
                }),
              ],
              1
            ),
            _vm.maxCharacters === 200
              ? _c(
                  "div",
                  {
                    staticClass: "alertMaxCharacters",
                    attrs: { "aria-live": "assertive", tabindex: "-1" },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$gettext("Has alcanzado el limite de caracteres")
                        ) +
                        " "
                    ),
                  ]
                )
              : _vm._e(),
            _c(
              "div",
              {
                class: [
                  "alertWrongCharacters",
                  this.wrongCharacters ? "show" : "hide",
                ],
                attrs: { "aria-live": "assertive", tabindex: "-1" },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$gettext("Solo se permiten letras y números")) +
                    " "
                ),
              ]
            ),
            _c(
              "div",
              {
                class: [
                  "alertWrongCharacters",
                  this.moderationError ? "show" : "hide",
                ],
                attrs: { "aria-live": "assertive", tabindex: "-1" },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$gettext("No podemos enviar este mensaje.")) +
                    " "
                ),
              ]
            ),
            _c("button", {
              staticClass: "action-icon send",
              class: {
                disabled:
                  this.message.trim(" ").length === 0 || this.isModerating,
              },
              style: _vm.config
                ? {
                    backgroundColor:
                      _vm.config.background_color + " !important",
                  }
                : {},
              attrs: {
                tabindex: "0",
                disabled:
                  this.message.trim(" ").length === 0 || this.isModerating,
                title: _vm.$gettext("Enviar mensaje"),
              },
              on: {
                click: _vm.getMessage,
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.getMessage.apply(null, arguments)
                },
              },
            }),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }